enum PlanningTaskType {
  DOSSIER = 'DOSSIER',
  INTERNAL = 'INTERNAL',
  ABSENCE = 'ABSENCE',
}

export default PlanningTaskType;
